import React from "react";

export default class TableView extends React.Component {
  render() {
    return (
      <>
        {this.props.entry.map((element, i) => (
          <div key={i}>
            <h6 className="card-subtitle mb-2 mt-4">{element.titlu}</h6>
            <hr className="w-25 ml-0 mt-0" />
            <table className="table table-borderless table-hover table-sm">
              <tbody>
                {element.entry.map((pers, i) => (
                  <tr key={i}>
                    <td className="text-capitalize">{pers.persoana.toLowerCase()}</td>

                    {pers.avere && (
                      <td className="text-right">
                        {pers.avere.fileName.map((avere, i) => (
                          <small key={i} className="text-muted d-block">
                            <a href={pers.avere.url + avere} target="_blank">
                              Declaraţie de avere
                            </a>
                          </small>
                        ))}
                      </td>
                    )}

                    {pers.interese && Array.isArray(pers.interese) && pers.interese.length && (
                      <td className="text-right">
                        {pers.interese.fileName.map((interese, i) => (
                          <small key={i} className="text-muted d-block">
                            <a href={pers.interese.url + interese} target="_blank">
                              Declaraţie de interese
                            </a>
                          </small>
                        ))}
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </>
    );
  }
}
